/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*@ngInject*/
export default function CopyEntityController($scope, $mdDialog, $q,
                                             agTypes,
                                             siloService,
                                             weatherStationService,
                                             agDeviceService,
                                             placeholderText,
                                             notFoundText,
                                             requiredText,
                                             entity,
                                             targetRootEntityId,
                                             targetEntityType,
                                             targetEntitySubtypes,
                                             newEntityNameText,
                                             newEntityNameRequiredText) {

    var vm = this;

    vm.agTypes = agTypes;
    vm.placeholderText = placeholderText;
    vm.notFoundText = notFoundText;
    vm.requiredText = requiredText;

    vm.entity = entity;
    vm.targetRootEntityId = targetRootEntityId;
    vm.targetEntityType = targetEntityType;
    vm.targetEntitySubtypes = targetEntitySubtypes;
    vm.newEntityNameText = newEntityNameText;
    vm.newEntityNameRequiredText = newEntityNameRequiredText;

    vm.targetEntityId = null;
    vm.copyCount = 1;
    vm.multipleCopiesLoading = false;

    if (vm.entity.name) {
        vm.entityName = vm.entity.name;
        vm.entity.name = '';
    }

    vm.copy = copy;
    vm.cancel = cancel;


    function cancel() {
        $mdDialog.cancel();
    }

    function copy() {
        var copyPromise;
        if (vm.copyCount > 1) {
            var copyTasks = [];
            vm.multipleCopiesLoading = true;
        }
        if (vm.entity.type == agTypes.assetType.silo && vm.copyCount == 1) {
            copyPromise = siloService.copySilo( vm.entity, vm.targetEntityId );
        } else if (vm.entity.type == agTypes.assetType.silo && vm.copyCount > 1) {
            for (var i = 0; i < vm.copyCount; i++) {
                var copyNumber = pad(i+1, 3);
                var copySilo = angular.copy(vm.entity);
                copySilo.name += " copy " +  copyNumber;
                copyTasks.push(siloService.copySilo( copySilo, vm.targetEntityId ));
            }
        } else if (vm.entity.type === agTypes.assetType.weatherStation) {
            copyPromise = weatherStationService.copyWeatherStation(vm.entity, vm.targetEntityId);
        } else if (vm.entity.type === agTypes.deviceType.temperatureSensorLines ||
            vm.entity.type === agTypes.deviceType.moistureSensorLines || vm.entity.type === agTypes.deviceType.co2SensorLines ||
            vm.entity.type === agTypes.deviceType.levelIndicator || vm.entity.type === agTypes.deviceType.headSpaceSensor) {
            copyPromise = agDeviceService.copySiloDevice( vm.entity, vm.targetEntityId );
        }
        if (copyPromise) {
            copyPromise.then(
                function success() {
                    $scope.theForm.$setPristine();
                    $mdDialog.hide(vm.targetEntityId);
                }
            );
        }
        if (copyTasks) {
            $q.all(copyTasks).then(
                function success() {
                    vm.multipleCopiesLoading = false;
                    $scope.theForm.$setPristine();
                    $mdDialog.hide(vm.targetEntityId);
                },
                function fail() {
                    vm.multipleCopiesLoading = false;
                    $scope.theForm.$setPristine();
                    $mdDialog.hide();
                }
            )
        }
    }

    function pad(num, size) {
        var s = num+"";
        while (s.length < size) s = "0" + s;
        return s;
    }
}